/**
 * Class description
 *
 * Created: 2018-03-05
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";


export class DebugInfoOverlay extends BaseView {
    private _debugInfo:PIXI.Text;
    private _layer:ScalableLayer;
    private _backplate:PIXI.Graphics;
    private _componentContainer:PIXI.Container;
    private _hideButton:PIXI.Graphics;
    private _infoOpen:boolean;
    private _moveOffset:PIXI.Point | null;
    private _prevData:IResizeData;
    private _contentWidth:number;
    private _contentHeight:number;


    constructor(layerName:string) {
        super(ResourcesGroupName.INTRO);
        this._layer = StageManager.getLayer(layerName);
        this._infoOpen = false;
    }

    protected initAnimations() {
        const textStyle:TextStyleOptions = {
            fontFamily : "Open Sans",
            fontSize : 20,
            fill : "#FFFFFF"
        };

        this._hideButton = new PIXI.Graphics();
        this._hideButton.interactive = true;

        this._debugInfo = new PIXI.Text("", textStyle);
        this._backplate = new PIXI.Graphics();
        this._componentContainer = new PIXI.Container();

        this._componentContainer.addChild(this._backplate);
        this._componentContainer.addChild(this._debugInfo);
        this._componentContainer.addChild(this._hideButton);

        this._componentContainer.position.set(10, 10);
        this._componentContainer.interactive = true;
        this._componentContainer.interactiveChildren = true;
        this._componentContainer.buttonMode = true;
        this._componentContainer.on('pointerdown', this.onDown.bind(this));
        this._componentContainer.on('pointerup', this.onUp.bind(this));
        this._hideButton.on('pointerup', this.onUp.bind(this));
        this._componentContainer.on('pointermove', this.onMove.bind(this));

        this._layer.addChild(this._componentContainer);
    }


    protected onResize(resizeData:IResizeData):void {
        this.updateDebugInfo(resizeData);
    }

    private updateDebugInfo(data:IResizeData, stateChange:boolean = false) {
        this._prevData = data;
        if(this._infoOpen == true) {
            this._debugInfo.text =
                "DEBUG INFO\n" +
                "resolution: " + StageManager.renderer.resolution + "\n" +
                "tl: " + data.top + ", " + data.left + "\n" +
                "br: " + data.bottom + ", " + data.right + "\n" +
                "size: " + data.width + "," + data.height + "\n" +
                "orien: " + data.orientation + "\n" +
                "aspect: " + (Math.max(data.width, data.height) / Math.min(data.width, data.height)).toFixed(3);
            this._debugInfo.alpha = 1;
        } else {
            this._debugInfo.text = "DEBUG INFO";
            this._debugInfo.alpha = 0.5;
        }

        this.drawButton();
        let margin = 10;
        this._debugInfo.position.set(margin, margin);
        let contentWidth = this._debugInfo.position.x + this._debugInfo.width + margin + this._hideButton.width + margin;
        let contentHeight = this._debugInfo.position.y + this._debugInfo.height + margin;

        if(stateChange == true) {
            this._contentWidth = contentWidth < this._contentWidth ? this._contentWidth : contentWidth;
        } else {
            this._contentWidth = contentWidth;
        }

        this._contentHeight = contentHeight;

        this._backplate.clear();
        this._backplate.lineStyle(2, 0xFFFFFF, 0.5);
        this._backplate.beginFill(0x000000, 0.3);
        this._backplate.drawRoundedRect(0, 0, this._contentWidth, this._contentHeight, 8);
        this._backplate.endFill();

        this._hideButton.position.set(this._backplate.width - this._hideButton.width - margin, margin);

    }

    private drawButton() {
        this._hideButton.clear();
        this._hideButton.lineStyle(2, 0xFFFFFF, 0.5);
        this._hideButton.beginFill(0x000000, 0.3);
        this._hideButton.drawRoundedRect(0, 0, 20, 20, 4);
        this._hideButton.endFill();

        this._hideButton.lineStyle(1, 0xFFFFFF, 1);
        if(this._infoOpen == true) {
            this._hideButton.moveTo(5, 12);
            this._hideButton.lineTo(10, 7);
            this._hideButton.lineTo(15, 12);
        } else {
            this._hideButton.moveTo(5, 9);
            this._hideButton.lineTo(10, 14);

            this._hideButton.lineTo(15, 9);
        }
    }

    private onDown(e:PIXI.InteractionEvent) {
        this._moveOffset = new PIXI.Point(
            e.data.global.x - this._componentContainer.x,
            e.data.global.y - this._componentContainer.y
        );
    }

    private onUp(e:PIXI.InteractionEvent) {
        this._moveOffset = null;

        if(e.currentTarget == this._hideButton) {
            e.stopPropagation();
            this._infoOpen = !this._infoOpen;
            this.updateDebugInfo(this._prevData, true);
        }

    }

    private onMove(e:PIXI.InteractionEvent) {
        if(this._moveOffset != null) {
            this._componentContainer.position.set(
                e.data.global.x - this._moveOffset.x,
                e.data.global.y - this._moveOffset.y
            );
        }
    }
}